import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { Observable, Subject, finalize, map } from 'rxjs';
import { atLeastOneFieldValidator } from 'src/app/utils/common/validators/at-least-one-field';
import { Generic } from 'src/app/interfaces/generic.interface';
import { Client } from '../../../client.interface';
import { ClientModulesService } from '../client-modules.service';
import { ModulesService } from '../../../../administration/admin-settings/modules/modules.service';

@Component({
	selector: 'app-add-client-module',
	templateUrl: './add-client-module.component.html',
	styleUrls: ['./add-client-module.component.scss'],
})
export class AddClientModuleComponent implements OnInit {
	// general error
	errorTitle: string = helper.dialogConfig.headers.errorAtentie;
	errorIcon: string = helper.dialogConfig.icons.error;
	errorType: string = helper.dialogConfig.icons.error;
	helper = helper;

	modulesActive$!: Observable<Generic[]>;

	parameters: { key: string; value: string }[] = [
		{ key: '--Alegeți--', value: '-1' },
		{ key: 'Da', value: '1' },
		{ key: 'Nu', value: '0' },
	];

	defaultParameter: { name: string; id: string } = {
		name: '--Alegeți--',
		id: '-1',
	};

	isLoading = false;
	form: FormGroup = new FormGroup({
		client_id: new FormControl(this.data.id_client, [Validators.required]),
		module_id: new FormControl('-1', [Validators.required]),
		display_name: new FormControl('', [Validators.required]),
		url_front_end: new FormControl('', [Validators.required]),
		url_back_end: new FormControl('', [Validators.required]),
	});

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: Client,
		private dialogRef: MatDialogRef<AddClientModuleComponent>,
		private clientModuleService: ClientModulesService,
		private notificationService: NotificationService,
		private modulesService: ModulesService,
	) { }

	ngOnInit(): void {
		this.loadModulesActive();
	}

	closeDialog() {
		this.dialogRef ?.close({ success: false });
	}

	loadModulesActive() {
		this.isLoading = true;
		this.modulesActive$ = this.modulesService.getModuleActive()
			.pipe(
				map((results: any) => [this.defaultParameter, ...results.data]),
				finalize(() => {
					this.isLoading = false;
				})
			);
	}

	submitForm() {
		if (!this.form.valid) return;

		this.isLoading = true;

		const payload = this.form.value;

		this.clientModuleService.addClientModule(payload)
			.pipe(finalize(() => (this.isLoading = false)))
			.subscribe({
				next: (res: any) => {
					this.dialogRef.close({ success: true });
				},
				error: (err: any) => {
					let msg;
					try {
						msg = err.error.errors.message[0];
					} catch (error) {
						msg = helper.dialogConfig.generalMessages.error;
					}
					this.notificationService.warningSwal(this.errorTitle, msg, this.errorIcon);
				},
			});
	}
}
